'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-pagelayer',
    cnRow = "".concat(CLASSNAME, "__row"),
    cnContent = "".concat(CLASSNAME, "__content"),
    cnNoBackground = "".concat(cnContent, "--no-background");
/**
 * 
 */

var PageLayer = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(PageLayer, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(PageLayer);

  function PageLayer() {
    _rollupPluginBabelHelpers.classCallCheck(this, PageLayer);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(PageLayer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          noBackground = _this$props.noBackground,
          style = _this$props.style;
      return /*#__PURE__*/React__default.createElement("div", {
        noPadding: true,
        className: classNames(CLASSNAME, cnRow, 'center-xs')
      }, /*#__PURE__*/React__default.createElement("div", {
        style: style,
        className: classNames(className, cnContent, _rollupPluginBabelHelpers.defineProperty({}, cnNoBackground, noBackground))
      }, children));
    }
  }]);

  return PageLayer;
}(React__default.Component);
PageLayer.propTypes = {
  /** Additional class name */
  className: PropTypes.string,
  children: PropTypes.node,
  noBackground: PropTypes.bool,
  style: PropTypes.object
};

module.exports = PageLayer;
